import {
  getTotalChargeFromBaseCurrencyAmount,
  getBaseAmountFromTotalCharge,
} from 'utils/helper-functions/amount-conversion.ts';
import { mathCeilDecimal } from '../round-functions/math-ceil-decimal';
import { numberFormat } from '../validations-functions/number-format';
import { round } from '../round-functions/round';
import store from '../../state/store';

export const calculateFee = (fees, amount, currency, type) => {
  let total = amount,
    fee = null,
    feeObj = null;
  if (!fees || !fees[currency] || !amount || !currency) return { total: total, fee };
  feeObj = findCurrentFee(fees[currency], total, currency);
  fee = changeFormatFee(feeObj, total, currency);
  total = findTotal(fee, total, currency, type);
  return { total, fee };
};

const changeFormatFee = (fee, total, currency) => {
  if (!fee) return fee;

  const { flat_fee_amount, percentage_fee, is_included, min_fee_amount, max_fee_amount } = fee;

  let flatFeeAmount = 0;
  let percentageFeeAmount = 0;
  let resultingFeeAmount = 0;

  if (flat_fee_amount) flatFeeAmount = +flat_fee_amount;
  if (percentage_fee)
    percentageFeeAmount = mathCeilDecimal((+total / 100) * +percentage_fee, currency);

  resultingFeeAmount = flatFeeAmount + percentageFeeAmount;

  if (min_fee_amount && resultingFeeAmount < min_fee_amount) resultingFeeAmount = +min_fee_amount;
  if (max_fee_amount && resultingFeeAmount > max_fee_amount) resultingFeeAmount = +max_fee_amount;

  const fee_value = numberFormat(resultingFeeAmount, currency, false, false, true);

  return {
    fee_value,
    is_included,
    percentage: percentage_fee,
    percentage_fee: percentageFeeAmount,
    flat_fee: flatFeeAmount,
    ...(min_fee_amount && { min_fee_amount }),
    ...(max_fee_amount && { max_fee_amount }),
  };
};

export const findCurrentFee = (feeArray, amount, currency) => {
  let currentFee = null;
  feeArray?.some((el) => {
    const minAmount = el.min_transaction_amount ?? 0;
    const maxAmount = el.max_transaction_amount ?? Infinity;
    if (Number(amount) >= Number(minAmount) && Number(amount) <= Number(maxAmount)) {
      currentFee = el;
      return true;
    }
  });
  return currentFee;
};

const findTotal = (feeObj, total, currency, type) => {
  const {
    initTheme: { theme_editor_settings: { customization_settings: { layout } = {} } = {} } = {},
  } = store.getState();
  if (!feeObj) return layout === 'amount-first' ? round(total, currency) : total;
  const { is_included, fee_value } = feeObj;
  if (is_included && type === 'pay-out')
    total = numberFormat(round(+total - +fee_value, currency), currency);
  if (!is_included) total = numberFormat(round(+total + +fee_value, currency), currency);

  return +total;
};

export const calculateAmountWithPercent = (fees, totalCharge, currency) => {
  const state = store.getState();
  const type = state.profileInfo?.transaction_type;

  const { total } = calculateFee(fees?.[currency], totalCharge, currency, type);
  return round(total, currency);
};
